import PropTypes from 'prop-types';

const propTypes = {
  clubs: PropTypes.object,
  competitions: PropTypes.object,
  seasons: PropTypes.object,
  rounds: PropTypes.object,
  dates: PropTypes.array,
  stadiums: PropTypes.object,
  carouselDates: PropTypes.object,
  sliderRef: PropTypes.object,
  getSlideRef: PropTypes.func,
  resetFilters: PropTypes.func,
  clubFilter: PropTypes.array,
  seasonFilter: PropTypes.array,
  roundFilter: PropTypes.array,
  dateFilter: PropTypes.string,
  stadiumFilter: PropTypes.array,
  carouselDatesFilter: PropTypes.string,
  setClubFilter: PropTypes.func,
  setCompetitionFilter: PropTypes.func,
  setSeasonFilter: PropTypes.func,
  setRoundFilter: PropTypes.func,
  setFromDateFilter: PropTypes.func,
  setToDateFilter: PropTypes.func,
  setStadiumFilter: PropTypes.func,
  setCarouselDatesFilter: PropTypes.func,
};

export { propTypes };
